import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '../baseQuery';

export type CollegeType = Readonly<{
  label: string;
  value: string;
}>;

export const collegeTypesApi = createApi({
  reducerPath: 'collegeTypesApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (build) => ({
    getCollegeTypes: build.query<CollegeType[], undefined>({
      query: () => 'college-types',
      keepUnusedDataFor: 60 * 60 * 24, // Cache for 24 hours
    }),
  }),
});

export const { useGetCollegeTypesQuery } = collegeTypesApi;
